export default {
    businessMatchHome: {
      howCanIHelp: 'How can I help you connect today?',
      findIdealMatches: 'Find Your Ideal Business Matches',
      matchWithMembers: 'Match with {title} members who can help grow your business',
      titleAll: 'ALL',
      stepOf: 'Step {current} of {total}',
      enterInfo: 'Enter Your Information',
      inputKeywords: 'Input Keywords',
      uploadPdf: 'Upload PDF',
      workEmail: 'Work Email',
      websiteUrl: 'Website URL',
      linkedinUrl: 'LinkedIn URL',
      placeholderKeywords: 'e.g., I’m a contractor looking for realtors to partner with...',
      keywordsDesc: 'Input keywords to find specific types of members or opportunities.',
      clickForExample: 'Click for quick example:',
      findMatches: 'Find My Matches',
      switchToDemandKeywords: 'Switch to demand keywords search',
      switchToSupplyKeywords: 'Switch to supply keywords search',
      keywordsExample1: 'Find criminal lawyer in Kaohsiung',
      keywordsExample2: 'Find sportswear factory, handle moisture-wicking fabric',
      keywordsExample3: 'Companies needing accounting services',
      keywordsExampleForCompany1: 'Looking for label display or e-paper',
      keywordsExampleForCompany2: 'Find customized industrial computer',
      keywordsExampleForCompany3: 'Virtual reality application vendors',
      supplyKeywordsExample1: 'TikTok live promotion in Asia',
      supplyKeywordsExample2: 'Connect brands with marketing execs',
      supplyKeywordsExample3: 'Cross-border logistics for Japan',
      supplyKeywordsExample1ForCes: 'Smartphone accessories manufacturer looking for distributors',
      supplyKeywordsExample2ForCes: 'Design firm offering ODM services for consumer electronics',
      supplyKeywordsExample3ForCes: 'Smart-home integration provider seeking hardware partners',
      examples: {
        other: {
          commonSearches: {
            title: 'Common Searches',
            examples: [
              'I provide home mortgage loans and want to find real estate agents',
              'I provide cleaning services and want to get referrals through property management companies',
              'Looking for companies that need accounting services',
              'Looking for health insurance services',
              'Looking for IT consultants',
              'Looking for interior contractors in Seattle'
            ]
          },
          newCustomerDevelopment: {
            title: 'New Customer Development',
            examples: [
              'Looking for customers who need auto loans',
              'Looking for customers who need photography services',
              'Looking for customers who need agricultural raw materials',
              'Looking for customers who need financial services',
              'Looking for customers who need third-party payment or cross-border payment solutions'
            ]
          },
          professionalServices: {
            title: 'Professional Services',
            examples: [
              'Looking for intellectual property attorneys',
              'Looking for social media marketing consultants',
              'Looking for professionals familiar with U.S. real estate exchange tax law',
              'Need compliance consultants familiar with Taiwan financial regulations',
              'Looking for one-on-one fitness coaching services'
            ]
          },
          businessNetworking: {
            title: 'Business Networking',
            examples: [
              "I'm a renovation company looking to get referrals from real estate agents for homeowners who need renovation services",
              "I'm an insurance agent looking to get referrals from car dealers for car owners who need auto insurance",
              'I provide charter bus services and want to find customers through travel agencies who need charter bus services',
              'I provide mobile notary services and want to get referrals through mortgage specialists'
            ]
          },
          regionalBusinessMatching: {
            title: 'Regional Business Matching',
            examples: [
              'Looking for web design companies in Taipei',
              'Looking for interior designers in New Taipei City',
              'Looking for port logistics companies in Kaohsiung'
            ]
          }
        },
        track47: {
          productAndTechnology: {
            title: 'Products & Technology',
            examples: [
              'Looking for NAS network storage device, must support RAID 10 configuration',
              'Looking for USB4 cable, must support 100W fast charging',
              'Looking for data center switches',
              'Looking for LiDAR sensor for autonomous vehicles',
              'Looking for suppliers with BCI (Brain-Computer Interface) and EEG (Electroencephalogram) technology',
              'Looking for smart products that assist people with mobility and visual impairments',
              'Looking for consumer electronics products that have won international design awards',
              'Looking for new technologies in entertainment and media'
            ]
          },
          solutions: {
            title: 'Solutions',
            examples: [
              'Looking for smart retail solutions',
              'Looking for edge computing solutions, must support 5G modules',
              'Looking for ESG carbon emission management solutions',
              'Looking for virtual reality application solutions'
            ]
          },
          businessPartners: {
            title: 'Business Partners',
            examples: [
              'Looking for AI startup accelerators',
              'Looking for electric vehicle technology partners',
              'Looking for holographic projection supply chain partners',
              'Looking for fintech companies to co-develop solutions',
              'Looking for agtech companies'
            ]
          },
          marketExpansion: {
            title: 'Market Expansion',
            examples: [
              'Looking for consumer electronics distributors',
              'Looking for cross-border e-commerce platforms',
              'Looking for channel promotion partners for interactive multimedia exhibitions'
            ]
          },
          mediaMarketing: {
            title: 'Media & Marketing',
            examples: [
              'Looking for media that covers industry news',
              'Looking for tech podcast collaborations',
              'Looking for international advertising agencies for integrated marketing'
            ]
          }
        },
        track8: {
          franchiseExamples: {
            title: 'Franchise Examples',
            examples: [
              'We need digital marketing and social media management services',
              'We need employee training and certification systems',
              'We need site evaluation and construction cost control services',
              'We provide franchise financing services',
              'We\'re a marketing services provider needing data analytics and marketing automation technology'
            ]
          }
        }
      },
      uploadYourFile: 'Upload Your File',
      dragPdfHere: 'Drag and drop PDF file here',
      releaseToUpload: 'Release to upload',
      orClickButton: 'or click the button below to select a file',
      selectFile: 'Select File',
      changeFile: 'Change File',
      clickToChange: 'Click the button below to change file',
      uploadPdfDescription: 'Upload your PDF (e.g., GAINs form) to find members you could collaborate with.',
      workEmailDescription: 'Input your work email to find members that might need the service or product for your company.',
      websiteUrlDescription: 'Input your website URL to find members that might need the service or product for your company.',
      linkedInUrlDescription: 'Input your LinkedIn URL to find members you could network with.',
      onboardingDialog: {
        title: 'Quick Profile Setup',
        description: 'This information helps us find the best business matches for you and improve your networking experience.',
        descriptionPage2: 'Complete Your Profile',
        yourNameLabel: 'Your Name',
        titleLabel: 'Title',
        jobTitleLabel: 'Job Title',
        emailLabel: 'Registration Email',
        phoneLabel: 'Phone',
        industryLabel: 'Industry',
        bioLabel: 'Bio',
        companyNameLabel: 'Company Name',
        companyWebsiteLabel: 'Company Website',
        websiteUsageHint: 'We\'ll use your website to better understand your business.',
        nextStep: 'Next',
        previousStep: 'Previous',
        complete: 'Complete',
        completeButton: 'Complete & Analyze',
        addMoreDetailsLater: 'You can add more details to your profile later'
      },
      snackbar: {
        closeButton: 'Close'
      },
      profileReminderSnackbar: {
        message: 'Complete your profile to get matched with the right people! ',
        completeNow: 'Complete Now →'
      },
      matchingProcess: {
        title: 'Matching',
        whatIsNamecardDoing: 'What is Namecard.ai doing?',
        analysisDescription: 'Namecard.ai analyzes your data to match you with ideal partners, providing reasons to connect and key talking points.'
      },
      validation: {
        personalEmailError: 'Please use your work email address instead of a personal or temporary email.',
        invalidEmailError: 'Please ensure you\'re using a valid email address',
        invalidLinkedInUrlError: 'Please ensure you\'re using a valid LinkedIn URL that starts with https://www.linkedin.com/in/',
        invalidUrlError: 'Please ensure you\'re using a valid URL',
        pdfOnlyError: 'Please upload PDF files only'
      },
      analyzing: 'Analyzing',
      progressStatus: {
        analyzingRequest: 'Analyzing your request...',
        searchingExhibitors: 'Finding matches...',
        smartMatching: 'Smart matching...',
        generatingResults: 'Generating results...'
      },
      errors: {
        pdfUploadFailed: 'PDF failed to upload. Please try again.',
        openaiUnavailable: 'OpenAI service is currently unavailable, please try again later.',
        fetchMatchFailed: 'Something went wrong. Let\'s try that again.',
        emptyQueryError: 'Unable to read document content. Please ensure the file is not password-protected, or upload a document with more text content for analysis.',
        incompleteUrlError: 'Please enter a complete URL and search again'
      },
      namecardAi: 'Namecard.ai',
      trackUserGroups: {
        track5: 'New users from BNI Taiwan',
        track6: 'New users from BNI USA',
        track7: 'New users from Computex',
        track0: 'New users from Namecard platform'
      },
      detailDrawer: {
        matchReasonTitle: 'Match Reasons'
      }
    },
    businessMatchContent: {
      title: 'Collaboration Items',
      matchingProcess: {
        title: 'Matching',
        whatIsNamecardDoing: 'What is Namecard.ai doing?',
        analysisDescription: 'Namecard.ai analyzes your data to match you with ideal partners, providing reasons to connect and key talking points.'
      },
      snackbar: {
        closeButton: 'Close'
      },
      errors: {
        openaiUnavailable: 'OpenAI service is currently unavailable, please try again later.',
        fetchMatchFailed: 'Something went wrong. Let\'s try that again.'
      },
      addButton: 'Add Collaboration Items',
      selectAllButton: 'Select All',
      deselectAllButton: 'Deselect All',
      startMatching: 'Start Matching',
      notCategorized: 'Not Categorized',
      originalQueryPrefix: 'Original Query: ',
      demandLabel: 'Needs',
      supplyLabel: 'I Offer',
      reasonPrefix: 'Reason: ',
      deleteDialog: {
        title: 'Confirm Delete',
        message: 'Are you sure you want to delete this option?',
        cancelButton: 'Cancel',
        confirmButton: 'Confirm'
      },
      addDialog: {
        title: 'Add Collaboration Item',
        inputLabel: 'Please enter keywords',
        cancelButton: 'Cancel',
        addButton: 'Add'
      },
      noOptionsTitle: 'Unable to Identify Collaboration Items',
      noOptionsMessage: 'The system could not identify clear collaboration items from the information provided. Please go back and enter more specific keywords or content.',
      backToHomeButton: 'Go Back and Re-enter',
      invalidQueryDialog: {
        title: 'Invalid Query',
        message: 'Your query did not generate new collaboration items. Please try entering more specific or different keywords.',
        confirmButton: 'OK'
      }
    },
    businessMatchHomePlaceholders: {
      workEmail: 'john@company.com',
      website: 'https://www.company.com',
      linkedin: 'https://www.linkedin.com/in/john',
      name: 'Enter your name',
      jobTitle: 'Enter your job title',
      companyName: 'Enter your company name',
      websiteShort: 'www.example.com',
      email: 'Enter the email you used to register',
      phone: 'Enter your phone number',
      industry: 'Select industries (max 5)',
      searchIndustry: 'Search industries...',
      bio: 'Tell us about yourself and your professional background...'
    },
    avatarMenu: {
      myProfile: 'My Profile',
      matches: 'Matches',
      supplyDemand: 'Collaboration Items',
      myContacts: 'My Contacts',
      emailSent: 'Sent Emails',
      chatChannels: 'Chat Channels',
      signOut: 'Sign Out',
      freePlan: {
        title: 'Free Plan',
        description: 'Get 30 days free trial! Enter your data to unlock premium features.',
        startTrialButton: 'Start Free Trial'
      },
      freeTrial: {
        title: 'Free Trial',
        daysLeft: '{days} days left',
        description: 'Extend your trial by 30 days! Share your feedback with us.',
        giveFeedbackButton: 'Give Feedback',
        upgradeButton: 'Upgrade'
      },
      premiumMember: {
        title: 'Premium Member',
        proBadge: 'Pro',
        description: 'Enjoying all premium features'
      },
      feedbackDialog: {
        title: 'We value your feedback',
        description: 'Please tell us how we can improve our product to make your experience better.',
        feedbackLabel: 'Your suggestions',
        feedbackRequired: '*',
        feedbackPlaceholder: 'Please enter your suggestions for improvement...',
        feedbackHelpText: 'Your feedback will help us improve our product features.',
        cancelButton: 'Cancel',
        submitButton: 'Submit Feedback'
      }
    },
    businessMatchResults: {
      matchScore: 'Match Score',
      explicitMatches: 'Explicit Matches Only',
      aiRecommendations: 'AI Recommendations Only',
      explicitMatchesLabel: 'Direct Matches',
      explicitMatchesTooltip: 'Shows results that directly match your needs or offerings',
      aiRecommendationsLabel: 'AI Recommendations',
      aiRecommendationsTooltip: 'AI-powered suggestions for potential business partners based on intelligent analysis',
      showAll: 'Show All',
      filterTitle: 'Filter',
      clearAllButton: 'Clear All',
      locationFilterLabel: 'Location',
      seeFewerOptions: 'See fewer options',
      seeAllOptions: 'See all options',
      industryFilterLabel: 'Industry',
      matchDirectionFilterLabel: 'Match Direction',
      matchQueryFilterLabel: 'Matched from your search',
      typeFilterLabel: 'Role',
      regionFilterLabel: 'Region',
      noMoreResults: 'No more results',
      applyFilterButton: 'Apply Filter',
      pageTitle: 'Your Personalized Matches',
      pageTitleMobile: 'Your Personalized Matches',
      pageSubtitle: 'Based on your needs, we\'ve generated a list of potential business partners. You can manually adjust your criteria to refine the results in real-time.',
      shareButton: 'Share',
      whatYourQuery: 'Your Match Query:',
      whyMatchThis: 'WHY THIS MATCH',
      savedButton: 'Saved',
      saveContactButton: 'Save Contact',
      profileReminder: {
        title: 'Complete Your Profile for 1 Month Free Premium',
        description: 'Fill out your profile to unlock more features',
        benefit1: 'View 100 search results',
        benefit2: 'Get higher exposure opportunities',
        benefit3: 'Display contact information for recommended results',
        laterButton: 'Later',
        goToProfileButton: 'Go to Profile'
      },
      unlockMoreResults: 'Unlock More Results',
      completeProfileToSeeMore: 'Complete your profile to see more results',
      platformUser: 'Platform User',
      learnMoreButton: 'View Details',
      noResultsFoundTitle: 'No results found.',
      noResultsFoundSubtitle: 'Please retry with a different source or keyword and match again.',
      retryButton: 'Retry',
      detailDrawer: {
        companyWebsiteTitle: 'Company Website',
        descriptionTitle: 'Description',
        iHaveTitle: 'Offerings',
        iWantTitle: 'Needs',
        matchSummaryTitle: 'Why this match',
        contactTitle: 'Contact',
        savedToContactsButton: 'Saved to Contacts',
        emailContactButton: 'Propose a Meeting',
        sendEmailButton: 'Send Email',
        bniMemberDetailButton: 'BNI Member Detail',
        connectButton: 'Connect',
        connectedButton: 'Connected',
        alreadyContacted: 'You’re already connected.',
        messageButton: 'Message',
        emailSentAndAddedToNetwork: 'Email sent and added to network',
        emailSendFailed: 'Failed to send email',
        addedToContactList: 'Added to contact list. Please go to chat channel to start a conversation.',
        addedToContacts: 'Added to contacts. Click the',
        chatChannel: 'Chat Channel',
        toStartConversation: ' to start a conversation.',
        contactSavedAndEmailSent: 'Successfully added to my contacts and email sent',
        contactSaved: 'Successfully added to my contacts',
        emailSent: 'Email sent successfully',
        connectSuccessConnected: "You're now connected. ",
        connectSuccessStartConversation: 'Start a conversation',
        connectSuccessAddedTo: 'Added to ',
        connectSuccessMyContacts: 'My Contacts',
        connectSuccessNotifiedByEmail: " — they've been notified by email",
        connectSuccessConnectedAddedTo: "You're now connected. Added to ",
        connectFailed: 'Failed to connect. Please try again.',
        incompleteProfile: 'Please complete your profile before connecting. ',
        goToProfile: 'Go to Profile'
      },
      sharingDialog: {
        title: 'Public link created',
        description: 'A public link to your matches has been created. Anyone with this link can view these matches.'
      },
      emailDialog: {
        sendEmailTo: 'Send Email To {name}',
        subjectLabel: 'Subject',
        messageLabel: 'Message',
        setUpAvailabilityButton: 'Set Up Availability',
        cancelButton: 'Cancel',
        sendEmailButton: 'Send Email'
      },
      emailSuccessDialog: {
        title: 'Email sent successfully!',
        descriptionLine1: 'Your introduction request has been sent to {name}.',
        descriptionLine2: 'Namecard.ai will help coordinate the meeting time between both parties.',
        viewSentEmailsButton: 'View Sent Emails',
        doneButton: 'Done'
      },
      sendEmailDialog: {
        title: 'Send Email to {name}',
        subjectLabel: 'Subject',
        subjectPlaceholder: 'Enter email subject',
        contentLabel: 'Email Content',
        contentPlaceholder: 'Enter your message to the recipient',
        systemNoteLabel: 'The following text will be included in the email',
        sharingNote: 'Here is my business card sharing link. Please feel free to review and contact me for business collaboration opportunities:',
        cancelButton: 'Cancel',
        sendButton: 'Send'
      }
    },
    businessMatchSavedContacts: {
      matchScore: 'Match Score',
      platformUser: 'Platform User',
      whatYourQuery: 'Your Match Query:',
      whyMatchThis: 'WHY THIS MATCH',
      viewMoreButton: 'View More',
      learnMoreButton: 'View Details',
      noSavedContactsTitle: 'Start building your network',
      noSavedContactsSubtitle: 'Save contacts you\'re interested in and they\'ll appear here.',
      findContactsButton: 'Find Contacts',
      noMoreResults: 'No more results',
      detailDrawer: {
        descriptionTitle: 'Description',
        iHaveTitle: 'Offerings',
        iWantTitle: 'Needs',
        matchSummaryTitle: 'Why this match',
        contactTitle: 'Contact',
        companyWebsiteTitle: 'Company Website',
        bniMemberDetailButton: 'BNI Member Detail',
        removeFromContactsButton: 'Remove From My Contacts',
        emailContactButton: 'Propose a Meeting',
        sendEmailButton: 'Send Email',
        addedToContacts: 'Added to contacts. Click the',
        chatChannel: 'Chat Channel',
        toStartConversation: ' to start a conversation.'
      },
      sendEmailDialog: {
        title: 'Send Email to {name}',
        subjectLabel: 'Subject',
        subjectPlaceholder: 'Enter email subject',
        contentLabel: 'Email Content',
        contentPlaceholder: 'Enter your message to the recipient',
        systemNoteLabel: 'The following text will be included in the email',
        sharingNote: 'Here is my business card sharing link. Please feel free to review and contact me for business collaboration opportunities:',
        cancelButton: 'Cancel',
        sendButton: 'Send'
      },
      emailDialog: {
        sendEmailTo: 'Send Email To {name}',
        subjectLabel: 'Subject',
        messageLabel: 'Message',
        setUpAvailabilityButton: 'Set Up Availability',
        cancelButton: 'Cancel',
        sendEmailButton: 'Send Email'
      },
      emailSuccessDialog: {
        title: 'Email sent successfully!',
        descriptionLine1: 'Your introduction request has been sent to {name}.',
        descriptionLine2: 'Namecard.ai will help coordinate the meeting time between both parties.',
        viewSentEmailsButton: 'View Sent Emails',
        doneButton: 'Done'
      },
      deleteDialog: {
        confirmation: 'Are you sure you want to delete {name} from your contacts?',
        cancelButton: 'Cancel',
        deleteButton: 'Delete'
      }
    },
    businessMatchSharingMatchResults: {
      pageTitle: 'Explore your curated business matches.',
      pageSubtitle: 'Someone thought these business connections might be valuable for you. Browse the curated list of potential partners.',
      whatYourQuery: 'Your Match Query:',
      whyMatchThis: 'WHY THIS MATCH',
      matchScore: 'Match Score',
      platformUser: 'Platform User',
      completeProfileToSeeMore: 'Complete your profile to see more results',
      savedButton: 'Saved',
      saveContactButton: 'Save Contact',
      learnMoreButton: 'Learn More',
      noResultsFoundTitle: 'No results found.',
      noResultsFoundSubtitle: 'Please retry with a different source or keyword and match again.',
      retryButton: 'Retry',
      detailDrawer: {
        descriptionTitle: 'Description',
        iHaveTitle: 'Offerings',
        iWantTitle: 'Needs',
        matchSummaryTitle: 'Why this match',
        contactTitle: 'Contact',
        savedToContactsButton: 'Saved to Contacts',
        emailContactButton: 'Propose a Meeting',
        companyWebsiteTitle: 'Company Website',
        bniMemberDetailButton: 'BNI Member Detail',
        addedToContacts: 'Added to contacts. Click the',
        chatChannel: 'Chat Channel',
        toStartConversation: ' to start a conversation.'
      },
      emailDialog: {
        sendEmailTo: 'Send Email To {name}',
        subjectLabel: 'Subject',
        messageLabel: 'Message',
        setUpAvailabilityButton: 'Set Up Availability',
        cancelButton: 'Cancel',
        sendEmailButton: 'Send Email'
      },
      emailSuccessDialog: {
        title: 'Email sent successfully!',
        descriptionLine1: 'Your introduction request has been sent to {name}.',
        descriptionLine2: 'Namecard.ai will help coordinate the meeting time between both parties.',
        viewSentEmailsButton: 'View Sent Emails',
        doneButton: 'Done'
      },
      pageTitleMobile: 'Your Personalized Matches',
      noMoreResults: 'No more results'
    },
    nonLoginBusinessMatch: {
      findIdealMatches: 'Find Your Ideal Business Matches',
      matchWithMembers: 'Match with {title} members who can help grow your business',
      matchWithMembersMobile: 'Match with {title} members who can help grow your business',
      titleAll: 'ALL',
      stepOf: 'Step {current} of {total}',
      enterInfo: 'Enter Your Information',
      inputKeywords: 'Input Keywords',
      uploadPdf: 'Upload PDF',
      workEmail: 'Work Email',
      websiteUrl: 'Website URL',
      linkedinUrl: 'LinkedIn URL',
      placeholderKeywords: 'e.g., I’m a contractor looking for realtors to partner with...',
      keywordsDesc: 'Input keywords to find specific types of members or opportunities.',
      clickForExample: 'Click for quick example:',
      findMatches: 'Find My Matches',
      switchToDemandKeywords: 'Switch to demand keywords search',
      switchToSupplyKeywords: 'Switch to supply keywords search',
      keywordsExample1: 'Find criminal lawyer in Kaohsiung',
      keywordsExample2: 'Find sportswear factory, handle moisture-wicking fabric',
      keywordsExample3: 'Companies needing accounting services',
      keywordsExampleForCompany1: 'Looking for label display or e-paper',
      keywordsExampleForCompany2: 'Find customized industrial computer',
      keywordsExampleForCompany3: 'Virtual reality application vendors',
      supplyKeywordsExample1: 'TikTok live promotion in Asia',
      supplyKeywordsExample2: 'Connect brands with marketing execs',
      supplyKeywordsExample3: 'Cross-border logistics for Japan',
      supplyKeywordsExample1ForCes: 'Smartphone accessories manufacturer looking for distributors',
      supplyKeywordsExample2ForCes: 'Design firm offering ODM services for consumer electronics',
      supplyKeywordsExample3ForCes: 'Smart-home integration provider seeking hardware partners',
      examples: {
        other: {
          commonSearches: {
            title: 'Common Searches',
            examples: [
              'I provide home mortgage loans and want to find real estate agents',
              'I provide cleaning services and want to get referrals through property management companies',
              'Looking for companies that need accounting services',
              'Looking for health insurance services',
              'Looking for IT consultants',
              'Looking for interior contractors in Seattle'
            ]
          },
          newCustomerDevelopment: {
            title: 'New Customer Development',
            examples: [
              'Looking for customers who need auto loans',
              'Looking for customers who need photography services',
              'Looking for customers who need agricultural raw materials',
              'Looking for customers who need financial services',
              'Looking for customers who need third-party payment or cross-border payment solutions'
            ]
          },
          professionalServices: {
            title: 'Professional Services',
            examples: [
              'Looking for intellectual property attorneys',
              'Looking for social media marketing consultants',
              'Looking for professionals familiar with U.S. real estate exchange tax law',
              'Need compliance consultants familiar with Taiwan financial regulations',
              'Looking for one-on-one fitness coaching services'
            ]
          },
          businessNetworking: {
            title: 'Business Networking',
            examples: [
              "I'm a renovation company looking to get referrals from real estate agents for homeowners who need renovation services",
              "I'm an insurance agent looking to get referrals from car dealers for car owners who need auto insurance",
              'I provide charter bus services and want to find customers through travel agencies who need charter bus services',
              'I provide mobile notary services and want to get referrals through mortgage specialists'
            ]
          },
          regionalBusinessMatching: {
            title: 'Regional Business Matching',
            examples: [
              'Looking for web design companies in Taipei',
              'Looking for interior designers in New Taipei City',
              'Looking for port logistics companies in Kaohsiung'
            ]
          }
        },
        track47: {
          productAndTechnology: {
            title: 'Products & Technology',
            examples: [
              'Looking for NAS network storage device, must support RAID 10 configuration',
              'Looking for USB4 cable, must support 100W fast charging',
              'Looking for data center switches',
              'Looking for LiDAR sensor for autonomous vehicles',
              'Looking for suppliers with BCI (Brain-Computer Interface) and EEG (Electroencephalogram) technology',
              'Looking for smart products that assist people with mobility and visual impairments',
              'Looking for consumer electronics products that have won international design awards',
              'Looking for new technologies in entertainment and media'
            ]
          },
          solutions: {
            title: 'Solutions',
            examples: [
              'Looking for smart retail solutions',
              'Looking for edge computing solutions, must support 5G modules',
              'Looking for ESG carbon emission management solutions',
              'Looking for virtual reality application solutions'
            ]
          },
          businessPartners: {
            title: 'Business Partners',
            examples: [
              'Looking for AI startup accelerators',
              'Looking for electric vehicle technology partners',
              'Looking for holographic projection supply chain partners',
              'Looking for fintech companies to co-develop solutions',
              'Looking for agtech companies'
            ]
          },
          marketExpansion: {
            title: 'Market Expansion',
            examples: [
              'Looking for consumer electronics distributors',
              'Looking for cross-border e-commerce platforms',
              'Looking for channel promotion partners for interactive multimedia exhibitions'
            ]
          },
          mediaMarketing: {
            title: 'Media & Marketing',
            examples: [
              'Looking for media that covers industry news',
              'Looking for tech podcast collaborations',
              'Looking for international advertising agencies for integrated marketing'
            ]
          }
        },
        track8: {
          franchiseExamples: {
            title: 'Franchise Examples',
            examples: [
              'We need digital marketing and social media management services',
              'We need employee training and certification systems',
              'We need site evaluation and construction cost control services',
              'We provide franchise financing services',
              'We\'re a marketing services provider needing data analytics and marketing automation technology'
            ]
          }
        }
      },
      uploadYourFile: 'Upload Your File',
      dragPdfHere: 'Drag and drop PDF file here',
      releaseToUpload: 'Release to upload',
      orClickButton: 'or click the button below to select a file',
      selectFile: 'Select File',
      changeFile: 'Change File',
      clickToChange: 'Click the button below to change file',
      uploadPdfDescription: 'Upload your PDF (e.g., GAINs form) to find members you could collaborate with.',
      workEmailDescription: 'Input your work email to find members that might need the service or product for your company.',
      websiteUrlDescription: 'Input your website URL to find members that might need the service or product for your company.',
      linkedInUrlDescription: 'Input your LinkedIn URL to find members you could network with.',
      membersDirectoryTitle: 'Members Directory',
      trustedByTitle: 'Trusted by',
      snackbar: {
        closeButton: 'Close'
      },
      matchingProcess: {
        title: 'Matching',
        whatIsNamecardDoing: 'What is Namecard.ai doing?',
        analysisDescription: 'Namecard.ai analyzes your data to match you with ideal partners, providing reasons to connect and key talking points.'
      },
      validation: {
        personalEmailError: 'Please use your work email address instead of a personal or temporary email.',
        invalidEmailError: 'Please ensure you\'re using a valid email address',
        invalidLinkedInUrlError: 'Please ensure you\'re using a valid LinkedIn URL that starts with https://www.linkedin.com/in/',
        invalidUrlError: 'Please ensure you\'re using a valid URL',
        pdfOnlyError: 'Please upload PDF files only'
      },
      analyzing: 'Analyzing',
      progressStatus: {
        analyzingRequest: 'Analyzing your request...',
        searchingExhibitors: 'Finding matches...',
        smartMatching: 'Smart matching...',
        generatingResults: 'Generating results...'
      },
      errors: {
        pdfUploadFailed: 'PDF failed to upload. Please try again.',
        openaiUnavailable: 'OpenAI service is currently unavailable, please try again later.',
        fetchMatchFailed: 'Error fetching match, please try again.',
        emptyQueryError: 'Unable to read document content. Please ensure the file is not password-protected, or upload a document with more text content for analysis.'
      },
      namecardAi: 'Namecard.ai'
    },
    nonLoginBusinessMatchPlaceholders: {
      workEmail: 'john@company.com',
      website: 'https://www.company.com',
      linkedin: 'https://www.linkedin.com/in/john'
    },
    timeCollection: {
      setTitle: 'Set Your Recurring Availability',
      timezoneQuestion: 'What timezone are you working in?',
      quickTemplatesTitle: 'Quick Templates',
      showBusinessHoursButton: 'SHOW BUSINESS HOURS',
      showAllHoursButton: 'Show All Hours',
      setWeeklyAvailabilityTitle: 'Set Your Weekly Availability',
      dragInstructionTooltip: 'Click and drag to select or deselect multiple time slots at once.',
      dragInstructionFooter: 'Click and drag to select multiple time slots at once',
      meetingDurationQuestion: 'How long should meetings be?',
      repeatWeeksQuestion: 'How many weeks should this repeat?',
      repeatUntilDate: 'Your availability will repeat until {date}',
      saveButton: 'Create Time Voting Meeting',
      days: {
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
        sunday: 'Sun'
      },
      templates: {
        business: 'Business Hours (9AM-5PM, Mon-Fri)',
        extended: 'Extended Hours (8AM-8PM, Mon-Fri)',
        weekends: 'Weekends Only (10AM-4PM, Sat-Sun)',
        mornings: 'Mornings Only (8AM-12PM, Mon-Fri)',
        afternoons: 'Afternoons Only (1PM-5PM, Mon-Fri)',
        evenings: 'Evenings Only (6PM-9PM, Mon-Fri)'
      },
      meetingDurations: {
        minutes: '{count} minutes'
      },
      repeatWeeks: {
        weeks: '{count} weeks',
        month: '1 month (4 weeks)',
        months: '{count} months ({count} weeks)' // For 2 and 3 months
      }
    },
    nonLoginBusinessMatchResults: {
      explicitMatches: 'Explicit Matches Only',
      aiRecommendations: 'AI Recommendations Only',
      explicitMatchesLabel: 'Direct Matches',
      explicitMatchesTooltip: 'Shows results that directly match your needs or offerings',
      aiRecommendationsLabel: 'AI Recommendations',
      aiRecommendationsTooltip: 'AI-powered suggestions for potential business partners based on intelligent analysis',
      showAll: 'Show All',
      loginError: 'Please open this page in your mobile browser to complete the login process.',
      filterTitle: 'Filter',
      clearAllButton: 'Clear All',
      locationFilterLabel: 'Location',
      seeFewerOptions: 'See fewer options',
      seeAllOptions: 'See all options',
      industryFilterLabel: 'Industry',
      matchDirectionFilterLabel: 'Match Direction',
      matchQueryFilterLabel: 'Matched from your search',
      typeFilterLabel: 'Role',
      regionFilterLabel: 'Region',
      applyFilterButton: 'Apply Filter',
      pageTitle: 'Your Personalized Matches',
      pageSubtitle: 'Based on your needs, we\'ve generated a list of potential business partners. You can manually adjust your criteria to refine the results in real-time.',
      shareButton: 'Share',
      whatYourQuery: 'Your Match Query:',
      whyMatchThis: 'WHY THIS MATCH',
      platformUser: 'Platform User',
      loginToSaveContactButton: 'Connect',
      loginToViewMore: 'Login/Sign Up',
      learnMoreButton: 'Learn More',
      noResultsFoundTitle: 'No results found.',
      noResultsFoundSubtitle: 'Please retry with a different source or keyword and match again.',
      retryButton: 'Retry',
      matchScore: 'Match Score',
      directionDemandToSupply: 'Demand Matching',
      directionSupplyToDemand: 'Supply Matching',
      directionBidirectional: 'Bidirectional',
      noMoreResults: 'No more results',
      detailDrawer: {
        descriptionTitle: 'Description',
        iHaveTitle: 'Offerings',
        iWantTitle: 'Needs',
        matchSummaryTitle: 'Why this match',
        companyWebsiteTitle: 'Company Website',
        contactTitle: 'Contact',
        loginToSaveContactButton: 'Connect',
        loginToViewContactsButton: 'View Contact',
        bniMemberDetailButton: 'BNI Member Detail'
      },
      loginPromptDialog: {
        title: 'Login to Connect!',
        message: 'Login/Sign Up to save contacts, view full contact information, and enjoy more exclusive features.',
        refineTitle: 'Unlock More Premium Matches',
        refineMessage: 'Login/Sign Up to unlock more premium matches, view complete contact details, and enjoy exclusive features.',
        loginButton: 'Login/Sign Up Now',
        cancelButton: 'Maybe Later'
      },
      sharingDialog: {
        title: 'Public link created',
        description: 'A public link to your matches has been created. Anyone with this link can view these matches.'
      },
      pageTitleMobile: 'Your Personalized Matches'
    },
    nonLoginSharingMatchResults: {
      pageTitle: 'Someone shared these business connections with you. Sign in to get contact details.',
      pageSubtitle: 'Someone thought these business connections might be valuable for you. Browse the curated list of potential partners.',
      whatYourQuery: 'Your Match Query:',
      whyMatchThis: 'WHY THIS MATCH',
      savedButton: 'Connected',
      saveContactButton: 'Connect',
      loginToSaveContactButton: 'Connect',
      learnMoreButton: 'Learn More',
      noResultsFoundTitle: 'No results found.',
      noResultsFoundSubtitle: 'Please retry with a different source or keyword and match again.',
      retryButton: 'Retry',
      detailDrawer: {
        descriptionTitle: 'Description',
        iHaveTitle: 'Offerings',
        iWantTitle: 'Needs',
        matchSummaryTitle: 'Why this match',
        contactTitle: 'Contact',
        companyWebsiteTitle: 'Company Website',
        savedToContactsButton: 'Connected',
        loginToSaveContactButton: 'Connect',
        saveContactButton: 'Connect'
      },
      loginToViewMore: 'Login/Sign Up',
      loginError: 'Please open this page in your mobile browser to complete the login process.',
      matchScore: 'Match Score',
      platformUser: 'Platform User',
      pageTitleMobile: 'Your Personalized Matches',
      whatCompanyOffersMobile: 'What This Company Offers:',
      whatPersonOffersMobile: 'What This Person Offers:',
      noMoreResults: 'No more results'
    },
    businessMatchProfile: {
      pageTitle: 'Edit Profile for Better Matching Result',
      pageSubtitle: 'Your profile serves as the basis for Namecard.ai\'s match recommendations and is not publicly visible to other users. You can edit it directly or upload new sources for AI to summarize.',
      editButton: 'Edit',
      uploadSourceButton: 'Upload Source',
      sourceLabel: 'Source',
      viewAction: 'View',
      deleteAction: 'Delete',
      lastUpdatedLabel: 'Last Updated',
      getYourMatchesButton: 'Get Your Matches',
      pageTitleMobile: 'Edit Profile for Better Matching Result',
      pageSubtitleMobileTooltip: 'Your profile serves as the basis for Namecard.ai\'s match recommendations and is not publicly visible to other users. You can edit it directly or upload new sources for AI to summarize.',
      historyButtonMobile: 'History',
      editProfileButtonMobile: 'Edit Profile',
      feedbackHowsYourProfile: 'How\'s Your Profile?',
      feedbackLetUsKnow: 'Let us know if it meets your expectations.',
      likeButton: 'Like',
      dislikeButton: 'Dislike',
      feedbackThanks: 'Thank you for your feedback!',
      discardChangesButton: 'Discard Changes',
      saveButton: 'Save',
      uploadSourceDialog: {
        title: 'Upload Source',
        subtitle: 'Upload new source, and Namecard.ai will analyze them to regenerate your personalized profile.',
        overwriteWarning: 'Please note: uploading will overwrite existing records.',
        addLinkedInTitle: 'Add Your LinkedIn Profile URL',
        learnMoreLink: 'Learn More',
        shareWebsiteTitle: 'Share Your Company Website',
        urlInformationGuideLink: 'URL Information Guide',
        uploadMaterialsTitle: 'Upload Company Materials',
        selectPdfButton: 'Select PDF to Upload',
        pdfSupportHint: 'Supported file type: PDF (Max 10MB)',
        closeButton: 'Close',
        insertButton: 'Insert'
      },
      deleteSourceDialog: {
        title: 'Are you sure you want to delete these source?',
        subtitle: 'Once deleted, Namecard.ai will regenerate your profile based on available information.',
        closeButton: 'Close',
        deleteButton: 'Delete Source'
      },
      learnMoreDialog: {
        title: 'How to Share Your LinkedIn Profile',
        step1Text: 'Make your LinkedIn profile public so we can access and analyze your information for better matching results.',
        step1Link: 'Learn how to adjust your privacy settings',
        step2Text: 'Visit your LinkedIn profile page, copy your profile URL, and paste it into the input field.',
        backButton: 'Back'
      },
      urlInfoDialog: {
        title: 'URL Information Guide',
        point1: 'Enter any URL with content about your business',
        point2: 'Must start with https://',
        point3: 'URLs must be publicly accessible',
        point4: 'Can include company websites, product pages, press releases, etc.',
        point5: 'We\'ll analyze the content to understand your business and create better matches',
        backButton: 'Back'
      },
      snackbar: {
        closeButton: 'Close'
      },
      generatingProfileTitle: 'Generating Profile',
      matchingTitle: 'Matching',
      urlHint: 'You might need to add prefix "www"',
      validation: {
        invalidLinkedInUrlError: 'Please ensure you\'re using a valid LinkedIn URL that starts with https://www.linkedin.com/in/',
        invalidUrlError: 'Please ensure you\'re using a valid URL',
        invalidPdfError: 'Please ensure you\'re using a valid PDF'
      },
      errors: {
        pdfUploadFailed: 'PDF failed to upload. Please try again.',
        maxSourcesExceeded: 'You can only upload up to 10 sources.',
        sourceLoadFailed: 'Source failed to load. Please re-provide a URL.',
        fetchMatchFailed: 'Error fetching match, please try again.'
      },
      notifications: {
        profileUpdatedWithSource: 'Your personal profile has been updated with the new source you provided.',
        profileUpdated: 'Your personal profile has been updated',
        sourcesDeletedProfileUpdated: 'Sources deleted, and your profile has been updated.',
        sourceDeleted: 'Your source has been successfully deleted.'
      }
    },
    userProfile: {
      myProfileTitle: 'My Profile',
      analyzing: 'Analyzing your profile',
      tabs: {
        basicInfo: 'Basic Info',
        suppliesAndDemands: 'Supplies & Demands',
        profilePreview: 'Profile Preview'
      },
      basicInfoSection: {
        title: 'Basic Information',
        profileStrength: 'Profile Strength: {value} %',
        fullNameLabel: 'Full Name',
        fullNamePlaceholder: 'Your full name',
        fullNameRequired: 'Please enter your full name',
        jobTitleLabel: 'Job Title',
        jobTitlePlaceholder: 'Your job title',
        emailLabel: 'Email',
        emailPlaceholder: 'Your email address',
        phoneLabel: 'Phone',
        phonePlaceholder: 'Your contact number',
        companyLabel: 'Company',
        companyPlaceholder: 'Your company name',
        locationLabel: 'Location',
        locationPlaceholder: 'City, Country',
        industryLabel: 'Industry ( select up to 5 )',
        industryPlaceholder: 'Select industries..',
        industriesSelected: '{count} industries selected',
        industriesSelectedCount: '{count}/5 industries selected',
        companyWebsiteLabel: 'Company Website',
        companyWebsitePlaceholder: 'www.example.com',
        linkedinUrlLabel: 'Linkedin URL',
        linkedinUrlPlaceholder: 'www.linkedin.com/in/yourprofile',
        pdfUploadLabel: 'Upload PDF',
        pdfUploadPlaceholder: 'Select PDF file',
        uploadButton: 'Upload',
        changeButton: 'Change',
        noIndustriesFound: 'No matching industries found',
        bioLabel: 'Bio',
        bioPlaceholder: 'Tell others about yourself and your professional background',
        saveButton: 'Saved',
        analyzeButton: 'Analyze',
        aiAnalyzeButton: 'AI Analyze'
      },
      suppliesDemandsSection: {
        title: 'Supplies & Demands',
        whatYouCanOfferTitle: 'What You Can Offer',
        addNewButton: 'Add New',
        whatYouAreLookingForTitle: 'What You\'re Looking For',
        previousStepButton: 'Previous Step',
        saveAndContinueButton: 'Saved & Continue'
      },
      profilePreviewSection: {
        title: 'Profile Preview',
        shareProfileButton: 'Share Profile',
        whatIOfferTitle: 'What I Offer',
        whatImLookingForTitle: 'What I\'m Looking For',
        noOfferingsAdded: 'No offerings added yet',
        previousStepButton: 'Previous Step',
        publishProfileButton: 'Publish Profile',
        publishSuccessfullyButton: 'Publish Successfully',
        publicAndPreviewButton: 'Public & Preview',
        publicLabel: 'Public',
        privateLabel: 'Public'
      },
      editDemandDialog: {
        title: 'Edit What You\'re Looking For'
      },
      editSupplyDialog: {
        title: 'Edit What You Offer'
      },
      addDemandDialog: {
        title: 'Add What You\'re Looking For'
      },
      addSupplyDialog: {
        title: 'Add What You Offer'
      },
      editDialogCommon: { // Keys common to edit/add dialogs for supply/demand
        titleLabel: 'Title(optional)',
        titlePlaceholder: 'Enter a title for this item',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Add more detail about this item',
        cancelButton: 'Cancel',
        saveChangesButton: 'Saved Changes'
      },
      addDialogCommon: { // Keys common to add dialogs for supply/demand
        addItemButton: 'Add Item'
      },
      // New UserProfile translations
      visibility: {
        public: 'Public',
        private: 'Public'
      },
      avatarUpload: {
        clickToChange: 'Click to change photo'
      },
      sections: {
        basicInfo: 'Basic Information',
        servicesAndDemands: 'Services & Demands',
        contactInfo: 'Contact Information',
        description: 'Description'
      },
      services: {
        title: 'What I Offer',
        titleDialog: 'Services I Provide',
        noServices: 'No services added yet',
        addService: 'Add Service',
        editService: 'Edit Service'
      },
      demands: {
        title: 'What I\'m Looking For',
        titleDialog: 'Demands I\'m Seeking', 
        noDemands: 'No demands added yet',
        addDemand: 'Add Demand',
        editDemand: 'Edit Demand'
      },
      form: {
        nameLabel: 'Name',
        namePlaceholder: 'Please enter your name',
        nameRequired: 'Name is required',
        jobTitleLabel: 'Job Title',
        jobTitlePlaceholder: 'Please enter your job title',
        jobTitleRequired: 'Job title is required',
        emailLabel: 'Email',
        emailPlaceholder: 'Please enter your email',
        emailRequired: 'Email is required',
        phoneLabel: 'Phone',
        phonePlaceholder: 'Please enter your phone number',
        companyNameLabel: 'Company Name',
        companyNamePlaceholder: 'Please enter your company name',
        companyNameRequired: 'Company name is required',
        locationLabel: 'Location',
        locationPlaceholder: 'Please enter your location',
        companyUrlLabel: 'Company Website',
        industryLabel: 'Industry',
        industryPlaceholder: 'Please select your industry',
        industryRequired: 'Industry is required',
        industryCount: 'Selected {count} / 5 industries',
        industryCountZero: 'Selected 0 / 5 industries',
        bioLabel: 'Personal Description',
        bioPlaceholder: 'Please enter your personal description',
        bioRequired: 'Personal description is required',
        pdfUploadLabel: 'Upload PDF',
        pdfPlaceholder: 'Select PDF file',
        uploadText: 'Upload',
        changeText: 'Change'
      },
      dialogs: {
        editProfile: 'Edit Profile',
        editServicesAndDemands: 'Edit Services & Demands',
        editDemand: 'Edit Demand',
        editService: 'Edit Service',
        addDemand: 'Add Demand',
        addService: 'Add Service',
        aiAnalysis: 'AI Analysis',
        aiTooltip: 'AI will intelligently analyze and generate relevant service demands and supply items based on your company name, company website, and uploaded PDF files'
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save',
        saveChanges: 'Save Changes',
        addItem: 'Add Item',
        edit: 'Edit'
      },
      placeholders: {
        demandDescription: 'Please enter demand description',
        serviceDescription: 'Please enter service description'
      },
      misc: {
        companyWebsite: 'Company Website',
        mobileVersionDeveloping: 'Mobile version is under development',
        descriptionLabel: 'Description',
        pdfUploaded: 'PDF uploaded'
      }
    },
    mainLayout: {
      homeBreadcrumb: 'Home',
      sharingBreadcrumb: 'Sharing',
      resultsBreadcrumb: 'Results',
      contentBreadcrumb: 'Collaboration Items',
      myProfileBreadcrumb: 'My Profile',
      myContactsBreadcrumb: 'My Contacts',
      emailSentBreadcrumb: 'Sent Emails',
      loginButton: 'Login/Sign Up',
      myProfile: 'My Profile',
      // webviewLoginMessage: 'For security reasons, login will open in your default browser. Continue?',
      loginError: 'Please open this page in your mobile browser to complete the login process.',
      nav: {
        matches: 'Matches',
        myProfile: 'My Profile',
        feedback: 'Feedback',
        contactUs: 'Contact Us'
      },
      freeTrialBanner: {
        title: 'You\'re currently on a free trial.',
        description: 'Upgrade to unlock all features and continue using the platform after your trial ends.',
        upgradeButton: 'Upgrade Now'
      }
    },
    businessMatchEmailSent:{
      searchPlaceholder: 'Search by recipient subject',
      to: 'To',
      sendTime: 'Send time'
    },
    nonLoginBusinessMatchContent: {
      title: 'Collaboration Items',
      matchingProcess: {
        title: 'Matching',
        whatIsNamecardDoing: 'What is Namecard.ai doing?',
        analysisDescription: 'Namecard.ai analyzes your data to match you with ideal partners, providing reasons to connect and key talking points.'
      },
      snackbar: {
        closeButton: 'Close'
      },
      errors: {
        openaiUnavailable: 'OpenAI service is currently unavailable, please try again later.',
        fetchMatchFailed: 'Error fetching match, please try again.'
      },
      addButton: 'Add Collaboration Items',
      selectAllButton: 'Select All',
      deselectAllButton: 'Deselect All',
      startMatching: 'Start Matching',
      notCategorized: 'Not Categorized',
      originalQueryPrefix: 'Original Query: ',
      demandLabel: 'Needs',
      supplyLabel: 'I Offer',
      reasonPrefix: 'Reason: ',
      deleteDialog: {
        title: 'Confirm Delete',
        message: 'Are you sure you want to delete this option?',
        cancelButton: 'Cancel',
        confirmButton: 'Confirm'
      },
      addDialog: {
        title: 'Add Collaboration Item',
        inputLabel: 'Please enter keywords',
        cancelButton: 'Cancel',
        addButton: 'Add'
      },
      noOptionsTitle: 'Unable to Identify Collaboration Items',
      noOptionsMessage: 'The system could not identify clear collaboration items from the information provided. Please go back and enter more specific keywords or content.',
      backToHomeButton: 'Go Back and Re-enter',
      invalidQueryDialog: {
        title: 'Invalid Query',
        message: 'Your query did not generate new collaboration items. Please try entering more specific or different keywords.',
        confirmButton: 'OK'
      }
    },
    common: {
      progressStatus: {
        analyzingRequest: 'Analyzing your request...',
        searchingMembers: 'Searching for relevant members...',
        smartMatching: 'Smart matching in progress...',
        generatingResults: 'Generating results...'
      }
    },
    pricing: {
      pageTitle: 'Pricing Plans',
      pageSubtitle: 'Choose the plan that suits you best',
      currentPlanChip: {
        premiumUser: 'You are currently using the Premium plan',
        freeUser: 'You are currently using the Free plan'
      },
      freePlan: {
        title: 'Free',
        price: '$0',
        searchResults: 'Search 3 results'
      },
      premiumPlan: {
        title: 'Premium',
        price: '$99',
        perMonth: '/month',
        recommendedBadge: 'Recommended',
        searchResults: 'Search 100 results',
        showContactInfo: 'Display recommended results contact information',
        higherExposure: 'Get higher exposure opportunities',
        freeTrialPromotion: 'Complete your profile to get one month of Premium membership',
        goToProfileButton: 'Go to Profile Page'
      }
    },
    sharingProfile: {
      profileTitle: 'Profile',
      addFriendButton: 'Add Friend',
      addFriendSuccess: 'Friend Added',
      loginToAddFriendButton: 'Login to Contact Me'
    },
    emailTemplates: {
      connectNonUser: {
        subject: '{sender_name} Is Trying to Reach You at IFA26!',
        content: 'Hi {user_name},\n\n{sender_name}, {sender_title} at {sender_company} wants to connect with you on Namecard.\n\nAbout {sender_name}:\n- Industry: {sender_industry}\n- Looking for: {sender_looking_for}\n- Why they want to connect: {sender_match_reason}\n\nNamecard uses AI to match IFA attendees by needs and offers — so you can start conversations online and make the most of your time at the event.\n\nSign up free to connect with the right people in IFA26!\n\n[Register to Accept →]\n\n— Namecard + IFA 2026'
      },
      connectUser: {
        subject: '{sender_name} just connected with you!',
        content: 'Hi {user_name},\n\nGood news! {sender_name} from {sender_company} wants to connect.\n\n{sender_name}\'s Profile:\n- Title: {sender_title}\n- Looking for: {sender_looking_for}\n- Offers: {sender_offers}\n\nLog in to accept and connect.\n\n[Login to Accept →]\n\n— Namecard + IFA 2026'
      },
      messageNonUser: {
        subject: 'You received a message from {sender_name} via Namecard',
        content: 'Hi {user_name},\n\n{sender_name}, {sender_title} at {sender_company} sent you a message:\n\nHere\'s my business card — feel free to review and get in touch:\n\n[View Business Card →]',
        fixedContent: 'Sign up free to start a conversation — 2 min.\n\n[Register to Message →]\n\n— Namecard + IFA 2026'
      },
      messageUser: {
        subject: '{sender_name} wants to connect',
        content: 'Hi {user_name},\n\nGood news! {sender_name} from {sender_company} wants to connect.\n\n{sender_name}\'s Profile:\n- Title: {sender_title}\n- Looking for: {sender_looking_for}\n- Offers: {sender_offers}\n\nLog in to accept and connect.\n\n[Login to Accept →]\n\n— Namecard + IFA 2026'
      }
    },
    chatRoom: {
      channels: 'Channels',
      members: 'members',
      searchPlaceholder: 'Search channels...',
      inputPlaceholder: 'Type a message...',
      selectChannelPrompt: 'Select a channel to start chatting',
      deleteConfirmTitle: 'Delete Conversation',
      deleteConfirmMessage: 'Are you sure you want to delete the conversation with {name}?',
      cancel: 'Cancel',
      delete: 'Delete',
      deleteConversation: 'Delete Conversation',
      noMessages: 'No messages yet',
      today: 'Today',
      yesterday: 'Yesterday'
    },
    nonLoginChatRoom: {
      loginPromptTitle: 'Login to Start Chatting',
      loginPromptMessage: 'Sign in to send messages and connect with your business partners.',
      loginButton: 'Login / Sign Up'
    }
  }